import {
  physicalWorldCreateOrderEnabled,
  physicalWorldGetTerminalEnabled,
  physicalWorldGetOrderEnabled,
  physicalWorldEnabled
} from '@/actions-permission/physical-world.permissions'

import { TERMINAL_ROUTES_ENUM } from '../enums/physical-world.enum'

const beforeEnterPhysicalWorldEnabled = store => {
  if (!physicalWorldEnabled(store.getters.permissionIsEnabled)) {
    return store.commit('toggleGlobalError', { status: true, code: 404 })
  }
}

const beforeEnterCreateOrderEnabled = store => {
  if (!physicalWorldCreateOrderEnabled(store.getters.permissionIsEnabled)) {
    return store.commit('toggleGlobalError', { status: true, code: 404 })
  }
}

const routeServiceOrders = store => [
  {
    path: 'service-orders',
    name: 'service-orders',
    component: () =>
      import(
        /* webpackChunkName: "ServiceOrders" */ '@/views/PhysicalWorld/ServiceOrders/ServiceOrders.vue'
      ),
    beforeEnter: (to, from, next) => {
      beforeEnterPhysicalWorldEnabled(store)

      const params = {
        accountId: to.params.account_id,
        merchantId: to.params.merchant_id
      }
      store.dispatch('GET_PHYSICAL_WORLD_ORDERS', params).then(() => {
        next()
      })
    },
    meta: {
      navigationBar: {
        label: 'breadcrumb.physical-world.service-orders'
      }
    }
  },
  {
    path: 'service-orders/:id',
    name: 'serviceOrdersDetail',
    component: () =>
      import(
        /* webpackChunkName: "ServiceOrdersDetails" */ '@/views/PhysicalWorld/ServiceOrders/ServiceOrdersDetails.vue'
      ),
    beforeEnter: (to, from, next) => {
      if (!physicalWorldGetOrderEnabled(store.getters.permissionIsEnabled)) {
        return store.commit('toggleGlobalError', { status: true, code: 404 })
      }
      const params = {
        id: to.params.id,
        accountId: to.params.account_id,
        merchantId: to.params.merchant_id
      }
      store
        .dispatch('GET_PHYSICAL_WORLD_ORDER_BY_ID', params)
        .then(() => next())
    },
    meta: {
      navigationBar: {
        label: 'breadcrumb.physical-world.service-orders-detail',
        navigateTo: () => ({
          name: 'service-orders'
        })
      }
    }
  }
]

const routePhysicalWorld = store => ({
  path: 'physical-world/',
  beforeEnter: (to, from, next) => {
    beforeEnterPhysicalWorldEnabled(store)
    next()
  },
  component: () =>
    import(
      /* webpackChunkName: "physical-world/index" */ '@/views/PhysicalWorld/index.vue'
    ),
  children: [
    {
      path: '',
      name: 'physical-world',
      redirect: { name: TERMINAL_ROUTES_ENUM.TERMINALS },
      beforeEnter: (to, from, next) => {
        beforeEnterPhysicalWorldEnabled(store)
        next()
      }
    },
    {
      path: 'terminals',
      name: TERMINAL_ROUTES_ENUM.TERMINALS,
      component: () =>
        import(
          /* webpackChunkName: "Terminals" */ '@/views/PhysicalWorld/Terminals/Terminals.vue'
        ),
      beforeEnter: (to, from, next) => {
        beforeEnterPhysicalWorldEnabled(store)
        next()
      },
      meta: {
        navigationBar: {
          label: 'breadcrumb.physical-world.terminals'
        }
      }
    },
    {
      path: 'terminals/request',
      name: TERMINAL_ROUTES_ENUM.TERMINAL_REQUEST,
      component: () =>
        import(
          /* webpackChunkName: "TerminalRequest" */ '@/views/PhysicalWorld/Terminals/TerminalRequest.vue'
        ),
      beforeEnter: (to, from, next) => {
        beforeEnterCreateOrderEnabled(store)
        next()
      },
      meta: {
        navigationBar: {
          label: 'breadcrumb.physical-world.terminals-request',
          navigateTo: () => ({
            name: TERMINAL_ROUTES_ENUM.TERMINALS
          })
        }
      }
    },
    {
      path: 'terminals/roll-request',
      name: TERMINAL_ROUTES_ENUM.TERMINAL_ROLL_REQUEST,
      component: () =>
        import(
          /* webpackChunkName: "TerminalRollRequest" */ '@/views/PhysicalWorld/Terminals/TerminalRollRequest.vue'
        ),
      beforeEnter: (to, from, next) => {
        beforeEnterCreateOrderEnabled(store)
        next()
      },
      meta: {
        breadcrumb: {
          refer: 'breadcrumb.physical-world.root',
          parents: [
            {
              name: 'breadcrumb.physical-world.terminals',
              routeName: TERMINAL_ROUTES_ENUM.TERMINALS
            }
          ],
          current: 'breadcrumb.physical-world.terminals-rollrequest'
        }
      }
    },
    {
      path: 'terminals/:id',
      name: TERMINAL_ROUTES_ENUM.TERMINAL_DETAILS,
      component: () =>
        import(
          /* webpackChunkName: "TerminalDetails" */ '@/views/PhysicalWorld/Terminals/TerminalDetails.vue'
        ),
      beforeEnter: (to, from, next) => {
        if (
          !physicalWorldGetTerminalEnabled(store.getters.permissionIsEnabled)
        ) {
          return store.commit('toggleGlobalError', { status: true, code: 404 })
        }
        const params = {
          query: {
            serialNumber: to.params.id,
            accountId: to.params.account_id,
            merchantId: to.params.merchant_id
          }
        }
        store.dispatch('GET_TERMINAL_BY_SERIAL_NUMBER', params).then(() => {
          next()
        })
      },
      meta: {
        navigationBar: {
          label: 'breadcrumb.physical-world.terminals-details',
          navigateTo: () => ({
            name: TERMINAL_ROUTES_ENUM.TERMINALS
          })
        }
      }
    },

    {
      path: 'terminals/uninstall/:serialNumber',
      name: TERMINAL_ROUTES_ENUM.TERMINAL_UNINSTALL,
      component: () =>
        import(
          /* webpackChunkName: "TerminalUninstallRequest" */ '@/views/PhysicalWorld/Terminals/TerminalUninstallRequest.vue'
        ),
      beforeEnter: (to, from, next) => {
        beforeEnterCreateOrderEnabled(store)
        const params = {
          query: {
            serialNumber: to.params.serialNumber,
            accountId: to.params.account_id,
            merchantId: to.params.merchant_id
          }
        }
        store.dispatch('GET_TERMINAL_BY_SERIAL_NUMBER', params).then(() => {
          next()
        })
      },
      meta: {
        breadcrumb: {
          refer: 'breadcrumb.physical-world.root',
          parents: [
            {
              name: 'breadcrumb.physical-world.terminals-details',
              routeName: TERMINAL_ROUTES_ENUM.TERMINAL_DETAILS
            }
          ],
          current: 'breadcrumb.physical-world.terminals-uninstall'
        }
      }
    },
    {
      path: 'terminals/swap/:serialNumber',
      name: TERMINAL_ROUTES_ENUM.TERMINAL_SWAP,
      component: () =>
        import(
          /* webpackChunkName: "TerminalSwapRequest" */ '@/views/PhysicalWorld/Terminals/TerminalSwapRequest.vue'
        ),
      beforeEnter: (to, from, next) => {
        beforeEnterCreateOrderEnabled(store)
        const params = {
          query: {
            serialNumber: to.params.serialNumber,
            accountId: to.params.account_id,
            merchantId: to.params.merchant_id
          }
        }
        store.dispatch('GET_TERMINAL_BY_SERIAL_NUMBER', params).then(() => {
          next()
        })
      },
      meta: {
        breadcrumb: {
          refer: 'breadcrumb.physical-world.root',
          parents: [
            {
              name: 'breadcrumb.physical-world.terminals-details',
              routeName: TERMINAL_ROUTES_ENUM.TERMINAL_DETAILS
            }
          ],
          current: 'breadcrumb.physical-world.terminals-swap'
        }
      }
    },
    ...routeServiceOrders(store)
  ]
})

export default routePhysicalWorld
